import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomTextFieldComponent } from './custom-text-field.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { ListSearchBoxComponent } from './list-search-box/list-search-box.component';

@NgModule({
  declarations: [CustomTextFieldComponent, SearchBoxComponent, ListSearchBoxComponent],
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  exports: [CustomTextFieldComponent, SearchBoxComponent, ListSearchBoxComponent],
  providers: []
})
export class CustomTextFieldModule {}
